export default "__VITE_ASSET__Bhj8vH1Q__"